import React from 'react';
import Header from '../Components/Header/header';
import Hero from '../Components/Hero/hero';
import AboutMe from '../Components/Aboutme/aboutme';
import CounterSection from '../Components/CounterSection/countersection';
import PortfolioCarousel from '../Components/PortfoloCarousel/portfoliocarousel';

// Import your project images
import project1Image from '../img/projects/project-1.png';
import project2Image from '../img/projects/project-2.png';
import project3Image from '../img/projects/project-3.png';
import project4Image from '../img/projects/project-4.png';
import project5Image from '../img/projects/project-5.png';
import project6Image from '../img/projects/project-6.png';
import project7Image from '../img/projects/project-7.png';
import project8Image from '../img/projects/project-8.png';
import project9Image from '../img/projects/project-9.png';
import project10Image from '../img/projects/project-10.png';
import project11Image from '../img/projects/project-11.png';
import project12Image from '../img/projects/project-12.png';
import project13Image from '../img/projects/project-15.png';
import project14Image from '../img/projects/project-16.png';
import project15Image from '../img/projects/project-17.png';
import project16Image from '../img/projects/project-18.png';
import project17Image from '../img/projects/project-19.png';
import project18Image from '../img/projects/project-20.png';
import project19Image from '../img/projects/project-21.png';
import project20Image from '../img/projects/project-22.png';
import project21Image from '../img/projects/project-23.png';
import project22Image from '../img/projects/project-24.png';
import project23Image from '../img/projects/project-25.png';
import project24Image from '../img/projects/project-26.png';
import project25Image from '../img/projects/project-27.png';
import project26Image from '../img/projects/project-28.png';
import project27Image from '../img/projects/project-29.png';
import project28Image from '../img/projects/project-30.png';
import project29Image from '../img/projects/project-31.png';
import project30Image from '../img/projects/project-32.png';
import project34Image from '../img/projects/project-34.png';
import project35Image from '../img/projects/project-35.png';
import project36Image from '../img/projects/project-36.png';
import Spacer from '../Components/Spacer/spacer';
import ResumeSection from '../Components/ResumeSection/resumesection';
import Carousel from '../Components/Tech/slick-carousel';
import CallToAction from '../Components/Calltoaction/calltoaction';
import Contact from '../Components/Contact/contact';
import Footer from '../Components/Footer/footer';
import DisableInteractions from '../Components/DisableInteractions/DisableInteractions';

const Home = () => {
  function handleCopy(event) {
    event.preventDefault();
  }

  function handleDragStart(event) {
    event.preventDefault();
  }

  function handleDrop(event) {
    event.preventDefault();
  }

  function handleContextMenu(event) {
    event.preventDefault();
  }
  const projects = [
    {
      id: 34,
      image: project34Image,
      name: 'React JS',
      link: 'https://cgifort.com/'
    },
    {
      id: 35,
      image: project35Image,
      name: 'React JS',
      link: 'https://cgiforge.com/'
    },
    {
      id: 36,
      image: project36Image,
      name: 'React JS',
      link: 'https://innosyncweb.netlify.app/'
    },
    {
      id: 1,
      image: project1Image,
      name: 'Custom Shopify Store Development',
      link: 'https://zilapz.com/'
    },
    {
      id: 2,
      image: project2Image,
      name: 'Shopify-dev',
           link: 'https://shoppermaze.com/'
    },
    {
      id: 3,
      image: project3Image,
      name: 'Shopify-dev',
          link: 'https://genrify.store/'
    },
    {
      id: 4,
      image: project4Image,
      name: 'Shopify-dev',
      link: 'https://healthysurprises.com/'
    },
    {
      id: 5,
      image: project5Image,
      name: 'Shopify-dev',
      link: 'https://thebeautifulglow.com/'
    },
    {
      id: 6,
      image: project6Image,
      name: 'Shopify-dev',
           link: 'https://thehomeandkitchen.com/'
    },
    {
    id: 7,
    image: project7Image,
    name: 'React JS',
    link: 'https://baltistanorganicdryfruits.netlify.app/'
  },
  {
    id: 8,
    image: project8Image,
    name: 'React JS',
    link: 'https://easycareskin.netlify.app/'
  },
  {
    id: 9,
    image: project9Image,
    name: 'React JS',
    link: 'https://cybernovadynamics.netlify.app/'
  },
  {
    id: 10,
    image: project10Image,
    name: 'React JS',
    link: 'https://carvillaprojectbywazirmubashir.netlify.app/'
  },
  {
    id: 11,
    image: project11Image,
    name: 'React JS',
    link: 'https://mubashir-dev.netlify.app/'
  },
  {
    id: 12,
    image: project12Image,
    name: 'React JS',
    
    link: 'https://superagency-inno.netlify.app/'
  },
  {
    id: 13,
    image: project13Image,
    name: 'Full-Stack dev',
    link: 'https://alimedicalcentreskd.netlify.app/'
  },
  {
    id: 14,
    image: project14Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 15,
    name: 'Front-end Dev',
    image: project15Image,
    link: '#'
  },
  {
    id: 16,
    image: project16Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 17,
    image: project17Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 18,
    image: project18Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 19,
    image: project19Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 20,
    image: project20Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 21,
    image: project21Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 22,
    image: project22Image,
    name: 'Front-end Dev',
    link: '#'
  },
  {
    id: 23,
    image: project23Image,
    name: 'Front-end Dev',
    link: 'https://anipat-pets.netlify.app/'
  },
  {
    id: 24,
    image: project24Image,
    name: 'Front-end Dev',
    link: 'https://pet-care-clinic.netlify.app/'
  },
  {
    id: 25,
    image: project25Image,
    name: 'Front-end Dev',
    link: 'https://builderzsite.netlify.app/'
  },
  {
    id: 26,
    image: project26Image,
    name: 'Front-end Dev',
    link: 'https://unitedtraveler.netlify.app/'
  },
  {
    id: 27,
    image: project27Image,
    name: 'Front-end Dev',
    link: 'https://idesigninteriordesigner.netlify.app/'
  },
  {
    id: 28,
    image: project28Image,
    name: 'Front-end Dev',
    link: 'https://burgerkingsite.netlify.app/'
  },
  {
    id: 29,
    image: project29Image,
    name: 'Front-end Dev',
    link: 'https://laundry-service-l.netlify.app/'
  },
  {
    id: 30,
    image: project30Image,
    name: 'Front-end Dev',
    link: 'https://royalcarrental.netlify.app/'
  }
];

  return (
    <div>
    <DisableInteractions>
      <Header />
      <Hero />
      <Spacer/>
      <AboutMe />
      <Spacer/>
      <CallToAction/>
      <Spacer/>
      <PortfolioCarousel projects={projects} />
      <Spacer/>
      <CounterSection />
      <Spacer/>
      <ResumeSection/>
      <Spacer/>
      <Carousel/>
      <Contact/>
      <Footer/>
</DisableInteractions>
    </div>
  );
}

export default Home;
